import {CabObj} from './index.js';

export enum AvailabilityState {
    closed,
    read,
    write,
}

export enum StatusEnum {
    future = 1,
    open,
    overdue,
    submitted,
    accepted,
    rejected
}

export enum PeriodEnum {
    Q = 1,
    H,
}

export enum OnderwerpEnum {
    mijlpaal = 1,
    adherentie,
    financien,
    personeel,
    productiviteit,
    quadrupleAim,
    toegankelijkheid,
    volumes,
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    proces   = 1, // extra alias
}

export enum KPITypeEnum {
    input = 1,
    output,
    onderliggend,
}

export enum PrognoseSchaalEnum {
    none = 1,
    once,
    all,
}

export enum WaardeTypeEnum {
    getal = 1,
    percentage,
    bedrag,
    decimaal,
}

export enum MijlpaalEnum {
    gehaald = 1,
    gemist,
    onbekend,
    gestart,
}

export enum KpiStatusEnum {
    gehaald = 1,
    gemist,
    onbekend
}

export enum MijlpaalPrognoseEnum {
    wordtGehaald = 1,
    kansOpMissen,
    wordtGemist
}

export enum KpiStatusPrognoseEnum {
    wordtGehaald = 1,
    kansOpMissen,
    wordtGemist
}

export enum WachttijdApiTypeEnum {
    MSZ = 1,
    GGZ,
}

export enum UnavailabilityReasonEnum {
    insufficientObservations = 1,
    aanmeldstop,
    unknown,
}

export type TreekNormCategory = 'Diagnostiek' | 'Polikliniekbezoek' | 'Behandeling' | 'GGZ_AanmeldGesprek' | 'GGZ_Behandeling';

export const SELECTOR_STARTS_WITH = '⬅';
export const SELECTOR_ENDS_WITH   = '➡';
export const SELECTOR_CONTAINS    = '↔';
export const SELECTOR_REGEXP      = '®';
export const SELECTOR_IS_NOT_NULL = '∃';

export enum Role {
    admin            = 'admin',
    reporter         = 'reporter',
    super_reporter   = 'super_reporter',
    acceptant        = 'acceptant',
    reporter_manager = 'reporter_manager',
    exporter         = 'exporter'
}

export enum Permission {
    admin            = 'admin',
    report           = 'report',
    api              = 'api',
    accept           = 'accept',
    export           = 'export',
    manage_reporters = 'manage_reporters'
}

export enum CrudAction {
    list   = 'list',
    create = 'create',
    update = 'update',
    delete = 'delete'
}

export type Selector = { [p: string]: SelectorValue; };
export type SelectorValue = string | string[] | number | number[] | CabObj | CabObj[] | boolean;